import { render, staticRenderFns } from "./catalogDropdown.vue?vue&type=template&id=2dd05726"
import script from "./catalogDropdown.vue?vue&type=script&lang=js"
export * from "./catalogDropdown.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports